import { useMutation, useQueryClient } from "@tanstack/react-query";

import { addCropExploration } from "services";

import { ADD_CROP_EXPLORATIONS, GET_CROP_EXPLORATIONS, GET_CROP_EXPLORATION_TEMPLATES } from "consts";

export const useAddCropExploration = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: [ADD_CROP_EXPLORATIONS],
    mutationFn: addCropExploration,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [GET_CROP_EXPLORATIONS, GET_CROP_EXPLORATION_TEMPLATES] });
    },
  });
};
